module.exports = __webpack_public_path__ + "img/s7pLogo3.31a1d94a.svg";